import React, { useState } from 'react';
import { DialogContentText } from '@mui/material';
import MediaUpload from './media-upload';
import { useApp } from '../../hooks/use-app';
import GalleryDisplay from './gallery-display';
import { Image, ProgressEvent } from './media-props';
import CustomConfirmDialog from '../../shared/material_components/custom-confirm-dialog';

interface Props {
  hidden?: boolean,
  images: Array<Image>,
  onAdd(metadata: Object, uploadedFile: Object): void,
  editing?: boolean,
  disabled?: boolean,
  title?: string,
  record: Record<string, any>,
}

const PhotoField: React.FC<Props> = ({
  hidden = false,
  images,
  onAdd,
  editing = false,
  disabled = false,
  title = '',
  record,
}: Props) => {
  const { api: { photos } } = useApp();
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [imageMediaID, setImageMediaID] = useState('');

  const uploadPhoto = (file: File,
    progress: (event: ProgressEvent) => void): Promise<Object> => (
    photos.create(
      file,
      { access_key: null },
      progress,
    )
  );
  const handleDeleteRequest = (mediaID: string, fromMediaViewer: boolean = false) => {
    setImageMediaID(mediaID);
    if (!fromMediaViewer) {
      setShowConfirmDialog(true);
    } else {
      setShowConfirmDialog(false);
      const img = images.find((image) => image.mediaID === mediaID);
      img?.onDelete(imageMediaID);
    }
  };

  const deletePhoto = () => {
    const img = images.find((image) => image.mediaID === imageMediaID);
    img?.onDelete(imageMediaID);
  };

  return (
    <>
      {
        !hidden && (
          <>
            <GalleryDisplay
              record={record}
              images={images}
              editing={editing}
              disabled={disabled}
              handleDeleteRequest={handleDeleteRequest}
              title={title}
              sx={{ mb: '16px' }}
            />
            <MediaUpload
              key="upload-photos"
              fileTypes="image/*"
              onMediaAdd={onAdd}
              uploadFile={uploadPhoto}
              disabled={disabled}
              buttonText={images.length ? 'Add more photos' : 'Add photo'}
            />
            <CustomConfirmDialog
              open={showConfirmDialog}
              onClose={() => setShowConfirmDialog(false)}
              title="Delete Media"
              positive="Delete Media"
              onNegative={() => setShowConfirmDialog(false)}
              onPositive={() => {
                setShowConfirmDialog(false);
                deletePhoto();
              }}
            >
              <DialogContentText component="span" data-testid="dialog-content">
                <p style={{ margin: 0 }}>
                  Are you sure you want to delete this media file ?
                </p>
              </DialogContentText>
            </CustomConfirmDialog>
          </>
        )
      }
    </>
  );
};

export default PhotoField;
